import React, { useState, useEffect, useRef } from 'react';
import './RankChangeIndicator.css';

const ARROW_DISPLAY_MS =
  (parseInt(process.env.REACT_APP_RANK_CHANGE_DISPLAY_SECONDS, 10) || 5) * 1000;

const RankChangeIndicator = ({ change, onShow, onDismiss }) => {
  const [visibleChange, setVisibleChange] = useState(null);
  const [animating, setAnimating] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (change !== null && change !== undefined && change !== 0) {
      setVisibleChange(change);
      setAnimating(true);
      if (onShow) onShow();

      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setAnimating(false);
        // Wait for the CSS fade-out transition to finish before clearing
        setTimeout(() => {
          setVisibleChange(null);
          if (onDismiss) onDismiss();
        }, 200);
      }, ARROW_DISPLAY_MS);
    }
  }, [change, onShow, onDismiss]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  if (visibleChange === null || visibleChange === 0) return null;

  const isUp = visibleChange > 0;
  const arrow = isUp ? '\u25B2' : '\u25BC';
  const magnitude = Math.abs(visibleChange);

  return (
    <div
      className={`rank-change ${isUp ? 'rank-change--up' : 'rank-change--down'} ${animating ? 'rank-change--visible' : 'rank-change--hidden'}`}
    >
      <span>{arrow}</span>
      <span>{magnitude}</span>
    </div>
  );
};

export default RankChangeIndicator;
